import React, { useState } from 'react';
import { Tabs } from 'antd';
import { BarChartOutlined, ThunderboltOutlined, ExportOutlined } from '@ant-design/icons';
import VisitorAnalytics from '../Analytics & Reports/VisitorAnalytics';
import EventsActions from '../Analytics & Reports/EventsActions';
import ExportReports from '../Analytics & Reports/ExportReports';
import '../admin.css';

const AnalyticsReportsPage = () => {
  const [activeTab, setActiveTab] = useState('visitors');

  const items = [
    {
      key: 'visitors',
      label: (
        <span>
          <BarChartOutlined />
          Visitor Analytics Logs
        </span>
      ),
      children: <VisitorAnalytics />,
    },
    {
      key: 'events',
      label: (
        <span>
          <ThunderboltOutlined />
          Events / Actions
        </span>
      ),
      children: <EventsActions />,
    },
    {
      key: 'export',
      label: (
        <span>
          <ExportOutlined />
          Export Reports
        </span>
      ),
      children: <ExportReports />,
    },
  ];

  return (
    <div className="abo-content">
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        size="large"
        style={{ marginBottom: 24 }}
      />
    </div>
  );
};

export default AnalyticsReportsPage;
